import { scrollToSection } from './scroll-to-section';

/** Ancres déjà présentes sur desktop ; deux accès supplémentaires seulement quand
 * les trois colonnes deviennent une pile verticale (<= 760 px). */
export function FinanceAnchors(): React.JSX.Element {
  return (
    <nav className="finance-anchors" aria-label="Raccourcis des rubriques financières">
      <span>Raccourcis :</span>
      <button
        className="finance-anchor--provisions"
        type="button"
        onClick={() => scrollToSection('finance-provisions')}
      >
        Que dois-je provisionner &amp; payer ?
      </button>
      <button
        className="finance-anchor--stack-only finance-anchor--revenue"
        type="button"
        onClick={() => scrollToSection('finance-revenue')}
      >
        Comment progresse mon CA ?
      </button>
      <button
        className="finance-anchor--expenses"
        type="button"
        onClick={() => scrollToSection('finance-expenses')}
      >
        Où part mon argent ?
      </button>
      <button
        className="finance-anchor--stack-only finance-anchor--treasury"
        type="button"
        onClick={() => scrollToSection('finance-treasury')}
      >
        Comment évolue ma trésorerie ?
      </button>
      <button
        className="finance-anchor--profitability"
        type="button"
        onClick={() => scrollToSection('finance-profitability')}
      >
        Quels projets et clients sont rentables ?
      </button>
    </nav>
  );
}
